import React, { useEffect, useState } from "react";
import Banner from "../../../Components/Common/Banner";
import {
  FaMapMarkerAlt,
  FaDollarSign,
  FaBriefcase,
  FaInfoCircle,
  FaCheckCircle,
  FaHeart,
  FaPaperPlane,
  FaSearch,
  FaPlus,
  FaPlusCircle,
  FaArrowDown,
} from "react-icons/fa";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Collapse, TextField } from "@mui/material";
import { FaArrowDownAZ, FaBook } from "react-icons/fa6";
import axios from "axios";
import job_banner_image from "../../../Assets/images/job_banner_image.png";
import { ToastContainer, toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

const Jobs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [descOpen, setDescOpen] = useState(false);
  const [jobData, setJobData] = useState([]);
  const [filteredJobData, setFilteredJobData] = useState([]);
  const handleOpen = (id) => {
    console.log(id);
    setOpen(true);
    setSelectedJob(id);
  };
  const handleClose = () => setOpen(false);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [cvUploadLoading, setCvUploadLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    coverLetter: "",
    cv: "",
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: name === "cv" ? files[0] : value,
    }));
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    if (term) {
      const filteredData = jobData.filter(
        (job) =>
          job.jobName.toLowerCase().includes(term) ||
          job.skillsRequired.some((skill) => skill.toLowerCase().includes(term))
      );
      setFilteredJobData(filteredData);
    } else {
      setFilteredJobData(jobData);
    }
  };

  const getJobData = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/job-openings/get-all-openings`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        setJobData(response?.data);
        setFilteredJobData(response?.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getJobData();
  }, []);

  const handleCVUpload = async (e) => {
    setCvUploadLoading(true);
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "techmentee"); // Replace with your Cloudinary upload preset
    try {
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/denarffyt/image/upload",
        formData
      );
      const cvUrl = response.data.secure_url;
      setFormValues((prevState) => ({
        ...prevState,
        cv: cvUrl,
      }));
      // toast.success('CV uploaded successfully!');
      console.log(formValues);
      setCvUploadLoading(false);
    } catch (error) {
      toast.error("CV upload failed!");
      console.error("CV upload error:", error);
      setCvUploadLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonLoading(true);
    let data = {
      jobId: selectedJob,
      name: formValues?.name,
      email: formValues?.email,
      phone: formValues?.phone,
      experience: formValues?.experience,
      coverLetter: formValues?.coverLetter,
      cvUrl: formValues?.cv,
    };

    console.log(data);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/applied-jobs/create-applied-job`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setFormValues({
          name: "",
          email: "",
          phone: "",
          experience: "",
          coverLetter: "",
          cv: "",
        });
        setSelectedJob("");
        toast.success(response?.data?.message);
        setButtonLoading(false);
        handleClose();
      })
      .catch((error) => {
        setButtonLoading(false);
        toast.error(error?.response?.data?.message);
        console.log(error);
      });
  };

  return (
    <div>
      <ToastContainer />
      <Banner
        pageName="Jobs"
        visible={true}
        buttonName="ENQUARY NOW"
        path="/contact-us/partner-with-us"
        breadcrummbs="Home / Contact Us / Career / Jobs"
        image={job_banner_image}
      />
      <div className="lg:px-20 md:px-10 px-5 py-10">
        {/* Search Bar */}
        <div className="mb-10 border border-dotted">
          <div className="flex items-center bg-white shadow-md rounded-md p-4">
            <FaSearch className="text-gray-500 mr-3" />
            <input
              type="text"
              placeholder="Search for jobs..."
              className="w-full py-2 px-4 text-gray-700 border-0 focus:outline-none"
              value={searchTerm}
              onChange={handleSearch}
            />
            {searchTerm !== "" && (
              <button
                className="text-secondaryTextColor font-bold"
                onClick={() => {
                  setFilteredJobData(jobData);
                  setSearchTerm("");
                }}
              >
                Clear
              </button>
            )}
          </div>
        </div>

        {isLoading ? (
          <div class="relative flex justify-center items-center">
            <div class="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-purple-500"></div>
            <img
              src="https://www.svgrepo.com/show/509001/avatar-thinking-9.svg"
              class="rounded-full h-28 w-28"
            />
          </div>
        ) : filteredJobData.length !== 0 ? (
          <div className="flex flex-col gap-4">
            {filteredJobData?.map((ele, index) => (
              <div className="p-6 bg-white shadow-md rounded-md border">
                <div className="border-b pb-4 mb-4">
                  <h1 className="text-2xl font-bold flex items-center">
                    <FaBriefcase className="mr-2" />
                    {ele?.jobName}
                  </h1>
                </div>

                <div className="mb-4 flex items-center">
                  <FaDollarSign className="mr-2" />
                  <span className="text-gray-700">
                    Rate/Price: ${ele?.rate} per month
                  </span>
                </div>

                <div className="mb-4 flex items-center">
                  <FaMapMarkerAlt className="mr-2" />
                  <span className="text-gray-700">
                    Location: {ele?.location}
                  </span>
                </div>

                <div className="mb-4 flex items-center">
                  <FaInfoCircle className="mr-2" />
                  <span className="text-gray-700">
                    Job Type: {ele?.jobType}
                  </span>
                </div>

                <div className="mb-4 flex items-center">
                  <FaBook className="mr-2" />
                  <span className="text-gray-700">
                    Skills Requirement: {ele?.skillsRequired + ""}{" "}
                  </span>
                </div>

                <div className="mb-4">
                  <h2
                    className="text-xl font-semibold mb-2 flex items-center cursor-pointer"
                    onClick={() =>
                      setDescOpen(descOpen === index ? null : index)
                    }
                  >
                    <FaArrowDown className="mr-2" /> Job Description
                  </h2>
                  <Collapse in={descOpen === index}>
                    <p className="text-gray-700">{ele?.jobDescription}</p>
                  </Collapse>
                </div>

                <div className="flex space-x-4">
                  <button
                    onClick={() => handleOpen(ele?._id)}
                    className="bg-blue-600 text-white py-2 px-4 rounded flex items-center"
                  >
                    <FaPaperPlane className="mr-2" /> Apply Now
                  </button>
                  {/* <button className="bg-gray-600 text-white py-2 px-4 rounded flex items-center"><FaHeart className="mr-2" /> Save Job</button> */}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-8 border flex items-center justify-center text-secondaryTextColor">
            Data not found
          </div>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Apply for Software Engineer
          </Typography>
          <Box component="form" sx={{ mt: 2 }}>
            <div className="border h-[70vh] overflow-y-scroll">
              {cvUploadLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-[#353c3b2f] bg-opacity-50 backdrop-blur-sm">
                  <div className="relative">
                    <div className="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-purple-500"></div>
                    <img
                      src="https://www.svgrepo.com/show/509001/avatar-thinking-9.svg"
                      className="rounded-full h-28 w-28 ml-4"
                      alt="Loading"
                    />
                  </div>
                </div>
              )}

              <div className="mb-2">
                <label htmlFor="name">Name:</label>
                <br />
                <input
                  onChange={handleInputChange}
                  value={formValues?.name}
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter your name"
                  style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                  className="border border-gray-400 rounded outline-none"
                />
              </div>
              <div className="mb-2">
                <label htmlFor="email">Email:</label>
                <br />
                <input
                  onChange={handleInputChange}
                  value={formValues?.email}
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                  className="border border-gray-400 rounded outline-none"
                />
              </div>
              <div className="mb-2">
                <label htmlFor="phone">Phone:</label>
                <br />
                <input
                  onChange={handleInputChange}
                  value={formValues?.phone}
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Enter your phone number"
                  style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                  className="border border-gray-400 rounded outline-none"
                />
              </div>
              <div className="mb-2">
                <label htmlFor="experience">Experience (years):</label>
                <br />
                <input
                  onChange={handleInputChange}
                  value={formValues?.experience}
                  type="number"
                  id="experience"
                  name="experience"
                  placeholder="Enter your experience in years"
                  style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                  className="border border-gray-400 rounded outline-none"
                />
              </div>
              <div className="mb-2">
                <label htmlFor="cover-letter">Cover Letter:</label>
                <br />
                <textarea
                  onChange={handleInputChange}
                  value={formValues?.coverLetter}
                  id="cover-letter"
                  name="coverLetter"
                  rows="4"
                  placeholder="Enter your cover letter"
                  style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                  className="border border-gray-400 rounded outline-none"
                ></textarea>
              </div>
              <div className="mb-2">
                <label htmlFor="cv">Upload CV (image format)</label>
                <br />
                <input
                  accept="application/pdf,image/*"
                  onChange={handleCVUpload}
                  type="file"
                  id="cv"
                  name="cv"
                  style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                  className="border border-gray-400 rounded outline-none"
                />
              </div>

              <button
                onClick={handleSubmit}
                disabled={isLoading}
                className="w-[200px] py-2 mt-4 text-white hover:bg-black cursor-pointer rounded-md flex items-center justify-center gap-2"
                style={{ backgroundColor: "#7A96BD" }}
              >
                {buttonLoading ? (
                  <>
                    <div class="rounded-md h-5 w-5 border-2 border-white animate-spin"></div>
                    Loading..
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Jobs;
